/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatsByRegionResponse {
    getFixupPrototypeFunction() { return SecurityDashboardThreatsByRegionResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatsByRegionResponse>): SecurityDashboardThreatsByRegionResponse {
        let obj = Object.assign(new SecurityDashboardThreatsByRegionResponse(), model);
        SecurityDashboardThreatsByRegionResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatsByRegionResponse>): SecurityDashboardThreatsByRegionResponse {
        if (!model) return null;
        return SecurityDashboardThreatsByRegionResponse.newInstance(<SecurityDashboardThreatsByRegionResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatsByRegionResponse) {
        if (!obj) return;

        models.SecurityDashboardThreatsByRegionResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatsByRegionResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatsByRegionResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_cloudprovider) {
            for (let val of this.summary_by_cloudprovider) {
                models.SecurityDashboardThreatsByRegionCount.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the threats by CloudProvider
     */
    summary_by_cloudprovider: Array<models.SecurityDashboardThreatsByRegionCount>;

}
